import { ActionTypes } from './action-types.enum';

export const addTemplates = (content) => ({
  type: ActionTypes.ADD_TEMPLATES,
  payload: {
    templates: content,
  }
});

export const setDefaultSelectedTemplate = (templateId) => ({
  type: ActionTypes.SET_DEFAULT_TEMPLATE,
  payload: {
    templateId,
  }
});

export const setLstUsedTemplate = (lastUsedTemplateId, template) => ({
  type: ActionTypes.SET_LAST_USED_TEMPLATE,
  payload: {
    lastUsedTemplateId,
    template,
  }
});
